import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { KitComponent } from './createKitComponent';
import type { WriteRequestOptions } from '../requestOptions';

export interface KitConfigurationData {
  product_id: number;
}

export interface KitConfigurationResponse {
  id: number;
  product_id: number;
  created_at?: string;
  created_by?: string;
  updated_at?: string;
  updated_by?: string;
  components?: KitComponent[];
}

export const createKitConfiguration = async (
  scope: RequestScope,
  data: KitConfigurationData,
  options: WriteRequestOptions
): Promise<EndpointResponse<KitConfigurationResponse>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<KitConfigurationResponse>>('/kit_configuration', data, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
